export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref10050.ea8441e8.jpg";